var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewService } from '../../view.service';
import { takeUntil } from 'rxjs/operators';
export class ViewChaptersComponent {
    // ---------- Lifecycle ----------
    constructor(store, viewService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Inputs ----------
        this.showHeader = true;
        this.showList = true;
        this.defaultImage = '/assets/images/view-chapter-thumbnail-placeholder.png';
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.nextChapter = null;
    }
    ngOnInit() {
        this.initChaptersObserver();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Observers ----------
    initChaptersObserver() {
        combineLatest([
            this.store.select(StoryChaptersState.getStoryChapters),
            this.store.select(StoryChaptersState.getSelectedChapterIndex)
        ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(([chapters, index]) => {
            const nextIndex = index + 1;
            this.nextChapter = (nextIndex >= chapters.length) ? null : chapters[nextIndex];
            this.changeDetectorRef.markForCheck();
        });
    }
    // ---------- Interaction ----------
    handleChapterClick(chapter) {
        this.viewService.selectChapter(chapter);
    }
    handleNextChapterClick() {
        this.viewService.nextChapter();
    }
    handleToggleList() {
        this.showList = !this.showList;
    }
    // ---------- Utility ----------
    getChapterThumb(chapterId) {
        const thumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        const thumbnail = thumbnails.get(chapterId);
        // use snapshot if present, otherwise use small
        if (!!thumbnail) {
            return thumbnail.snapshot || thumbnail.urls.small;
        }
        else {
            return '';
        }
    }
}
__decorate([
    Select(StoryChaptersState.getStoryChapters),
    __metadata("design:type", Observable)
], ViewChaptersComponent.prototype, "chapters$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterId),
    __metadata("design:type", Observable)
], ViewChaptersComponent.prototype, "selectedChapterId$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterIndex),
    __metadata("design:type", Observable)
], ViewChaptersComponent.prototype, "selectedChapterIndex$", void 0);
__decorate([
    Select(StoryChaptersState.getRegisteredThumbnails),
    __metadata("design:type", Map)
], ViewChaptersComponent.prototype, "thumbnails$", void 0);
